import _ from 'lodash';
import _forEach from 'lodash/map';
import React, { Component, PropTypes } from 'react';
import {connect} from 'react-redux';
import { formatDateWithAffiliateZipcode, elapsedTimeFrom } from '../utils/DateUtils';
import { authorsToString, bylineToString } from '../utils/NewsUtils';
import SocialIcon from '../components/social/SocialIcon';


const LONG_DATE_FORMAT = 'dddd, MMMM Do Y, h:mm a z';
const SHORT_DATE_FORMAT = 'MMMM Do, h:mm a';
const MAX_DURATION_DISPLAY_DIFFERENT_TIME_IN_SECOND = 60 * 60 * 24;
const SOCIAL_CONNECTS = [
  {
    key: 'facebook',
    url: '//facebook.com/'
  },
  {
    key: 'instagram',
    url: '//instagram.com/'
  },
  {
    key: 'google',
    url: '//plus.google.com/u/1/'
  },
  {
    key: 'emailaddress',
    url: 'mailto:'
  },
  {
    key: 'twitter',
    url: '//twitter.com/'
  }
];

/**
 * Class representing a timestamp of an element on the page, with the option of displaying the authors
 */

class Timestamp extends Component {
  static propTypes = {
    publishDate: PropTypes.string,
    displayShortDateTime: PropTypes.bool,
    showElapsedTime: PropTypes.bool,
    authors: PropTypes.node,
    separateByline: PropTypes.bool,
    bylines: PropTypes.array,
    showEmailAndSocialConnect: PropTypes.bool,
    affiliateZipcode: PropTypes.string,
  }

  static defaultProps = {
    showElapsedTime: false,
    displayShortDateTime: false,
    separateByline: false
  }

  state = {
    indexSocialConnect: -1
  }


  _showSocialConnect(index) {
    const {
      indexSocialConnect
    } = this.state;
    if (indexSocialConnect === index) {
      this.setState({
        indexSocialConnect: -1
      });
    } else {
      this.setState({
        indexSocialConnect: index
      });
    }
  }

  _getFormatedDay(dayString) {
    const { showElapsedTime, displayShortDateTime, affiliateZipcode} = this.props;
    const dateToCaculate = new Date(dayString);
    const now = new Date();
    const elapsedTimeInMiliSecs = now - dateToCaculate;

    if (showElapsedTime && elapsedTimeInMiliSecs < MAX_DURATION_DISPLAY_DIFFERENT_TIME_IN_SECOND * 1000) {
      return `${elapsedTimeFrom(dateToCaculate)} ago`;
    } else {
      const formatDate = displayShortDateTime ? SHORT_DATE_FORMAT : LONG_DATE_FORMAT;
      return formatDateWithAffiliateZipcode(dayString, formatDate)(affiliateZipcode);
    }
  }

  _getDestinationUri(socialValue, socialKey) {
    const matchSocialConnect = _.find(SOCIAL_CONNECTS, social => {
      return social.key === socialKey;
    });
    return !_.isEmpty(matchSocialConnect) ? matchSocialConnect.url + socialValue : '';
  }

  _separateByline(bylines = []) {
    const separateBylines = [];
    const {
      showEmailAndSocialConnect = false
    } = this.props;
    const {
      indexSocialConnect
    } = this.state;
    _forEach(bylines, (byline, index) => {
      const socialConnect = [];
      const {
        socialnetworksinfo
      } = byline;
      _.map(socialnetworksinfo, (socialValue, socialKey) => {
        const destinationUri = this._getDestinationUri(socialValue, socialKey);
        socialConnect.push(<SocialIcon key={socialKey} destinationUri={destinationUri} iconType={socialKey}/>);
      });
      const isShowSocialConnect = (showEmailAndSocialConnect && (indexSocialConnect === index));
      separateBylines.push(<div key={index} className="Timestamp-author--separated"><span onClick={() => this._showSocialConnect(index)}>By <b>{bylineToString(byline)}</b></span><div className="Timestamp-author--socialConnect">{isShowSocialConnect ? socialConnect : null}</div></div>);
    });
    return separateBylines;
  }

  render() {
    const { publishDate, authors, separateByline, bylines } = this.props;

    let authorContent;
    if (authors && authors.length) {
      authorContent = <span className="Timestamp-author">{authorsToString(authors)}</span>;
    }

    return (
      <div className={separateByline ? "Timestamp BylineSocialNetwork" : "Timestamp"}>
        <div className="Timestamp-text">
          {publishDate ? <span className="Timestamp-time">{this._getFormatedDay(publishDate)}</span> : null}
          {publishDate && (authors && authors.length) && !separateByline ? <span className="Timestamp-connector">{' by '}</span> : ''}
          {separateByline ? this._separateByline(bylines) : authorContent }
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  affiliateZipcode: state && state.affiliateZipcode ? String(state.affiliateZipcode) : '94107'
});

export default connect(mapStateToProps)(Timestamp);



// WEBPACK FOOTER //
// ./app/components/Timestamp.js